import React from 'react'

import MediaAnswer from 'lemon-campaign-ui/lib/molecules/MediaAnswer'
import linkChildren from '../link-children'

const emptyValue = {}

export default ({ component, defaults, recursive, handlers }) => {
  const childs = recursive(component.components)
  const linked = linkChildren(childs, defaults,
    component.content.linking.isInternal)

  return (
    <MediaAnswer
      {...defaults}
      boxed={false}
      value={component.content.value || emptyValue}
      borderRadius={component.content.borderRadius}
      clickHandler={() => {handlers.answer(component)}}

      // link={linking(component)} -- handled via js in templates/page.js
      bouncy
    >
      {linked}
    </MediaAnswer>
  )
}
